var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardMedia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 444,
    height: 291,
    viewBox: "0 0 444 291",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.494 175.596C169.102 175.596 202.831 138.079 202.831 91.7982C202.831 45.5177 169.102 8 127.494 8C85.8868 8 52.1572 45.5177 52.1572 91.7982C52.1572 138.079 85.8868 175.596 127.494 175.596Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 28.1203C24 58.6094 41.196 83.2808 62.4469 83.2808L24 28.1203Z",
    fill: "#2F2E41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.447 83.2808C62.447 52.4491 81.6367 27.5005 105.352 27.5005L62.447 83.2808Z",
    fill: "#10389A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9299 30.8844C37.9299 59.8458 48.8955 83.281 62.4468 83.281L37.9299 30.8844Z",
    fill: "#10389A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.447 83.2807C62.447 43.8846 84.6273 12.0058 112.038 12.0058L62.447 83.2807Z",
    fill: "#2F2E41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3586 83.6701C54.3586 83.6701 59.811 83.4833 61.4543 82.1818C63.0975 80.8804 69.8414 79.3263 70.2491 81.4136C70.6567 83.5009 78.443 91.7948 72.2873 91.8501C66.1315 91.9053 57.9841 90.7835 56.344 89.6724C54.704 88.5612 54.3586 83.6701 54.3586 83.6701Z",
    fill: "#A8A8A8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72.3971 91.1232C66.2414 91.1784 58.094 90.0567 56.4539 88.9455C55.2049 88.0993 54.7072 85.0628 54.5407 83.6619C54.4253 83.6674 54.3586 83.6698 54.3586 83.6698C54.3586 83.6698 54.704 88.5609 56.344 89.6721C57.9841 90.7833 66.1315 91.905 72.2873 91.8498C74.0642 91.8338 74.678 91.1306 74.6443 90.0892C74.3974 90.7184 73.7197 91.1113 72.3971 91.1232Z",
    fill: "#121212"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2471 185.014C130.776 185.014 160.388 180.533 160.388 175.006C160.388 169.479 130.776 164.998 94.2471 164.998C57.7185 164.998 28.1062 169.479 28.1062 175.006C28.1062 180.533 57.7185 185.014 94.2471 185.014Z",
    fill: "#3F3D56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M94.2469 183.408C124.915 183.408 149.777 179.646 149.777 175.006C149.777 170.365 124.915 166.603 94.2469 166.603C63.5785 166.603 38.7168 170.365 38.7168 175.006C38.7168 179.646 63.5785 183.408 94.2469 183.408Z",
    fill: "#121212"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M319.904 283C375.186 283 420 276.219 420 267.853C420 259.488 375.186 252.707 319.904 252.707C264.623 252.707 219.809 259.488 219.809 267.853C219.809 276.219 264.623 283 319.904 283Z",
    fill: "#3F3D56"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M133.861 271.05C167.069 271.05 193.989 266.977 193.989 261.952C193.989 256.927 167.069 252.854 133.861 252.854C100.653 252.854 73.7327 256.927 73.7327 261.952C73.7327 266.977 100.653 271.05 133.861 271.05Z",
    fill: "#3F3D56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M187.622 254.28C219.455 263.329 280.644 242.478 287.364 218.872",
    stroke: "#2F2E41",
    strokeWidth: 1.02714,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M133.507 109.895C133.507 109.895 179.487 95.7323 182.317 141.369C185.147 187.005 144.472 199.988 176.304 209.037",
    stroke: "#2F2E41",
    strokeWidth: 1.02714,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M89.084 219.378C89.084 219.378 102.904 215.121 103.754 228.837C104.605 242.553 92.3794 246.456 101.947 249.175",
    stroke: "#2F2E41",
    strokeWidth: 1.02714,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M299.424 229.589L296.637 249.376C296.637 249.376 282.921 257.482 292.565 257.72C302.21 257.959 347.647 257.72 347.647 257.72C347.647 257.72 356.435 257.72 342.503 249.138L339.717 228.397L299.424 229.589Z",
    fill: "#2F2E41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M290.625 257.505C292.815 255.338 296.637 253.079 296.637 253.079L299.424 233.292L339.717 233.334L342.503 252.84C345.752 254.842 347.765 256.376 348.942 257.553C350.731 257.099 352.687 255.411 342.503 249.138L339.717 228.397L299.424 229.589L296.637 249.376C296.637 249.376 285.111 256.188 290.625 257.505Z",
    fill: "#121212"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M403.741 91.6754H234.971C231.446 91.6754 228.589 94.8539 228.589 98.7749V225.231C228.589 229.152 231.446 232.33 234.971 232.33H403.741C407.266 232.33 410.124 229.152 410.124 225.231V98.7749C410.124 94.8539 407.266 91.6754 403.741 91.6754Z",
    fill: "#2F2E41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M404.015 99.1853H234.697V204.557H404.015V99.1853Z",
    fill: "#3F3D56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M319.356 97.0392C319.948 97.0392 320.428 96.5055 320.428 95.8472C320.428 95.1889 319.948 94.6553 319.356 94.6553C318.764 94.6553 318.285 95.1889 318.285 95.8472C318.285 96.5055 318.764 97.0392 319.356 97.0392Z",
    fill: "#F2F2F2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M410.124 212.901V225.231C410.124 226.163 409.959 227.086 409.638 227.948C409.317 228.809 408.847 229.592 408.254 230.251C407.662 230.91 406.958 231.433 406.184 231.79C405.409 232.147 404.579 232.33 403.741 232.33H234.971C234.133 232.33 233.303 232.147 232.529 231.79C231.754 231.433 231.051 230.91 230.458 230.251C229.865 229.592 229.395 228.809 229.074 227.948C228.754 227.086 228.589 226.163 228.589 225.231V212.901H410.124Z",
    fill: "#2F2E41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M366.723 270.594V272.978H251.415V271.07L251.573 270.594L254.415 262.011H364.365L366.723 270.594Z",
    fill: "#2F2E41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M411.097 268.26C410.887 269.258 410.094 270.312 408.302 271.309C401.872 274.884 388.798 270.355 388.798 270.355C388.798 270.355 378.725 268.448 378.725 263.442C379.008 263.226 379.303 263.031 379.608 262.858C382.311 261.267 391.274 257.342 407.167 263.024C408.338 263.433 409.384 264.195 410.188 265.226C410.832 266.064 411.337 267.128 411.097 268.26Z",
    fill: "#2F2E41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M411.097 268.26C403.227 271.614 396.212 271.864 389.012 266.302C385.382 263.499 382.083 262.805 379.608 262.858C382.311 261.267 391.274 257.342 407.167 263.024C408.338 263.433 409.383 264.195 410.188 265.226C410.832 266.064 411.337 267.128 411.097 268.26Z",
    fill: "#121212"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M401.229 266.303C402.768 266.303 404.015 265.876 404.015 265.349C404.015 264.822 402.768 264.395 401.229 264.395C399.69 264.395 398.443 264.822 398.443 265.349C398.443 265.876 399.69 266.303 401.229 266.303Z",
    fill: "#F2F2F2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M319.356 227.205C321.605 227.205 323.428 225.177 323.428 222.675C323.428 220.174 321.605 218.146 319.356 218.146C317.107 218.146 315.284 220.174 315.284 222.675C315.284 225.177 317.107 227.205 319.356 227.205Z",
    fill: "#F2F2F2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M366.723 270.594V272.978H251.415V271.071L251.573 270.594H366.723Z",
    fill: "#121212"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M135.983 70.5537H62.4146V165.761H135.983V70.5537Z",
    fill: "#2F2E41"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M143.411 61.1117H54.9868V94.9457H143.411V61.1117Z",
    fill: "#3F3D56"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M143.411 101.24H54.9868V135.074H143.411V101.24Z",
    fill: "#3F3D56"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M143.411 141.369H54.9868V175.203H143.411V141.369Z",
    fill: "#3F3D56"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M125.726 67.0127H120.067V73.3072H125.726V67.0127Z",
    fill: "#10389A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M133.861 67.0127H128.202V73.3072H133.861V67.0127Z",
    fill: "#10389A"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M141.996 67.0127H136.337V73.3072H141.996V67.0127Z",
    fill: "#10389A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M125.726 106.748H120.067V113.042H125.726V106.748Z",
    fill: "#10389A"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M133.861 106.748H128.202V113.042H133.861V106.748Z",
    fill: "#10389A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M141.996 106.748H136.337V113.042H141.996V106.748Z",
    fill: "#10389A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M125.726 146.483H120.067V152.778H125.726V146.483Z",
    fill: "#10389A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M133.861 146.483H128.202V152.778H133.861V146.483Z",
    fill: "#10389A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M141.996 146.483H136.337V152.778H141.996V146.483Z",
    fill: "#10389A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M135.983 250.739C151.415 250.739 163.925 236.824 163.925 219.659C163.925 202.494 151.415 188.579 135.983 188.579C120.551 188.579 108.041 202.494 108.041 219.659C108.041 236.824 120.551 250.739 135.983 250.739Z",
    fill: "#2F2E41"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M131.739 244.051H123.25V260.968H131.739V244.051Z",
    fill: "#2F2E41"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M148.716 244.051H140.227V260.968H148.716V244.051Z",
    fill: "#2F2E41"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M130.324 264.116C134.231 264.116 137.398 262.795 137.398 261.165C137.398 259.535 134.231 258.214 130.324 258.214C126.417 258.214 123.25 259.535 123.25 261.165C123.25 262.795 126.417 264.116 130.324 264.116Z",
    fill: "#2F2E41"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M147.301 263.722C151.208 263.722 154.375 262.401 154.375 260.772C154.375 259.142 151.208 257.821 147.301 257.821C143.394 257.821 140.227 259.142 140.227 260.772C140.227 262.401 143.394 263.722 147.301 263.722Z",
    fill: "#2F2E41"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M136.69 222.413C141.965 222.413 146.24 217.657 146.24 211.791C146.24 205.924 141.965 201.168 136.69 201.168C131.416 201.168 127.141 205.924 127.141 211.791C127.141 217.657 131.416 222.413 136.69 222.413Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M136.69 215.331C138.448 215.331 139.874 213.746 139.874 211.791C139.874 209.835 138.448 208.25 136.69 208.25C134.932 208.25 133.507 209.835 133.507 211.791C133.507 213.746 134.932 215.331 136.69 215.331Z",
    fill: "#3F3D56"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M108.878 190.756C106.622 179.517 113.834 168.16 124.987 165.39C136.14 162.62 147.01 169.485 149.266 180.725C151.522 191.964 144.131 196.109 132.978 198.879C121.825 201.649 111.135 201.995 108.878 190.756Z",
    fill: "#10389A"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M162.19 213.46C169.283 210.083 174.261 205.338 173.308 202.861C172.355 200.384 165.832 201.114 158.738 204.491C151.645 207.868 146.667 212.613 147.62 215.09C148.573 217.567 155.096 216.837 162.19 213.46Z",
    fill: "#2F2E41"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M109.843 234.312C116.936 230.935 121.914 226.189 120.961 223.712C120.008 221.235 113.485 221.965 106.391 225.342C99.2978 228.719 94.32 233.465 95.2731 235.942C96.2262 238.419 102.749 237.689 109.843 234.312Z",
    fill: "#2F2E41"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M152.253 228.708C152.253 231.749 145.211 237.756 137.398 237.756C129.584 237.756 122.189 232.143 122.189 229.101C122.189 226.059 129.584 226.741 137.398 226.741C145.211 226.741 152.253 225.666 152.253 228.708Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardMedia);
export default __webpack_public_path__ + "static/media/_CardMedia_.5450f3d9999b10d283f94eba7f8b3a92.svg";
export { ForwardRef as ReactComponent };